import Icon from "@components/global/new/Icon/Icon";
import styles from "./NodeIcon.module.scss"
import { ConsumerKind, NodeFigure } from "@store/connections/actionTypes";
import figures from "./figures";
import lighten from "@utils/lighten";
import rackIcon from '@assets/icons/rack.svg';
import minerIcon from '@assets/icons/miner.svg';
import buildingIcon from '@assets/icons/building.svg';

const icons: {[kind in ConsumerKind]: string | undefined} = {
  "miner": minerIcon,
  "rack": rackIcon,
  "building": buildingIcon,
}

interface NodeIconProps {
  icon: string;
  size?: number;
  color?: string;
  figure?: NodeFigure;
  figureColor?: string;
  consumer?: ConsumerKind;
};

interface FigureProps {
  figure: NodeFigure;
  icon: string;
  baseColor: string;
}

export const Figure = (props: FigureProps) => {
  const Fig = figures[props.figure];
  return (
    <div className={styles.figure}>
      {/*<Icon src={props.icon} className={styles.icon}/>*/}
      <Fig size={20} strokeWidth={90} fill={lighten(props.baseColor, 0.05)} stroke={lighten(props.baseColor, -0.5)}/>
    </div>
  )
}

const NodeIcon = (props: NodeIconProps) => {
  const color = props.color ?? "rgba(0,0,0,0)";
  const size = props.size ?? 20;
  const iconSize = Math.round(0.8*size);
  const colorSize = Math.round(0.4*size);
  return (
    <div 
      style={{width: size, height: size}}
      className={styles.container}
    >
      { props.figure
        ? <Figure icon={props.icon} figure={props.figure} baseColor={props.figureColor ?? "#DFF9E8"}/>
        : <Icon
            src={props.consumer ? (icons[props.consumer] ?? props.icon) : props.icon}
            style={{width: iconSize, height: iconSize}}
          />
      }

      <div 
        className={styles.color} 
        style={{
          backgroundColor: color,
          width: `${colorSize}px`, height: `${colorSize}px`,
          borderRadius: `${Math.floor(colorSize/2)}px`,
          right: `calc(3px - ${Math.floor(colorSize/2)}px)`,
          bottom: `calc(50% - ${Math.floor(colorSize/2)}px)`
        }}
      />
    </div>
  );
};

export default NodeIcon;